import api from './api';

const countryEventsService = {
  getEvents: async () => (await api.get('/partners/country-events')).data,
  createEvent: async (data) => (await api.post('/partners/country-events', data)).data,
  updateEvent: async (eventId, data) => (await api.put(`/partners/country-events/${eventId}`, data)).data,
  deleteEvent: async (eventId) => (await api.delete(`/partners/country-events/${eventId}`)).data,
  goLive: async (eventId) => (await api.post(`/partners/country-events/${eventId}/go-live`)).data,
  endEvent: async (eventId) => (await api.post(`/partners/country-events/${eventId}/end`)).data,
  getRegistrations: async (eventId) => (await api.get(`/partners/country-events/${eventId}/registrations`)).data,
};

export default countryEventsService;
